// Global API: embed.js exposes CrestaVoiceWidget.mount() so the host page
// can call it after the script loads.
//
// mount() creates an iframe so the widget runs in its own window context,
// avoiding custom-element conflicts when the host page already has df-messenger
// or another Cresta widget registered.
(window as Window & { CrestaVoiceWidget?: unknown }).CrestaVoiceWidget = {
  mount(container: HTMLElement, vertical: string, apiBase = location.origin, _scrollContainer: HTMLElement | null = null) {
    if ((container as HTMLElement & { __cvMounted?: boolean }).__cvMounted) return;
    (container as HTMLElement & { __cvMounted?: boolean }).__cvMounted = true;

    const iframe = document.createElement("iframe");
    iframe.src = `${apiBase}/${vertical}`;
    iframe.allow = "microphone; autoplay";
    iframe.style.cssText = "width:100%;height:calc(100vh - 180px);min-height:640px;border:none;display:block;";
    container.appendChild(iframe);
  },
};
